module.exports = __webpack_public_path__ + "img/public/siteImages/gallery.svg?f221df95";